import { debounce } from "lodash"
import { useLayoutEffect, useState } from "react"

const useWindowSize = () => {
  const [size, setSize] = useState({
    width: null,
    height: null,
  })

  useLayoutEffect(() => {
    const updateSize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    const handleResize = debounce(updateSize, 250)

    // Respond to element appearance immediately
    updateSize()
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return size
}

export { useWindowSize }
